export default "__VITE_ASSET__Gwy4U5oa__"